import React from 'react';

interface ViewToggleProps {
  viewMode: 'table' | 'card';
  setViewMode: (mode: 'table' | 'card') => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  setViewMode,
}) => {
  return (
    <div className="view-toggle-container">
      <div className="view-toggle">
        <i
          className={`pi pi-table cursor-pointer ${viewMode === 'table' ? 'active' : ''}`}
          onClick={() => setViewMode('table')}
        />
        <i
          className={`pi pi-th-large cursor-pointer ${viewMode === 'card' ? 'active' : ''}`}
          onClick={() => setViewMode('card')}
        />
      </div>
    </div>
  );
};
